import { UseMutationOptions } from '@tanstack/react-query';
import classNames from 'classnames';
import { useEffect } from 'react';
import { HttpError } from '~/components/Error/HttpError';
import { DefaultFace } from '~/components/Icon/DefaultFace';
import {
  LevelUpToken,
  LevelUpTokenValues,
  useIssueToken,
} from '~/components/LevelUp/LevelUp.hooks';
import styles from './LevelUpTokenIssuer.module.scss';

export type LevelUpTokenIssuerProps = {
  className?: string;
} & Pick<UseMutationOptions<LevelUpToken, HttpError, LevelUpTokenValues>, 'onSuccess' | 'onError'> &
  LevelUpTokenValues;
export const LevelUpTokenIssuer = ({
  level,
  tokenIdList,
  className,
  onSuccess,
}: LevelUpTokenIssuerProps) => {
  const { mutate } = useIssueToken({
    onSuccess,
    useErrorBoundary: true,
  });

  useEffect(() => {
    mutate({
      level,
      tokenIdList,
    });
  }, [tokenIdList, mutate, level]);

  return <DefaultFace className={classNames(styles.root, className)} />;
};
